module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page",
    class: {
      'bg-white': _vm.$vuetify.breakpoint.width <= 1280
    },
    staticStyle: {
      "background-color": "black"
    }
  }, [_c('v-container', {
    staticClass: "no-top-nav no-side-space",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "login-outer"
  }, [_c('div', {
    class: {
      'login-view': _vm.$vuetify.breakpoint.width > 1280
    }
  }, [(_vm.$vuetify.breakpoint.width > 1280) ? _c('v-btn', {
    staticClass: "absolute ma-0 btn-close",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push("/")
      }
    }
  }, [_c('v-icon', {
    staticClass: "font-size-34",
    staticStyle: {
      "background-color": "black"
    }
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "auth"
  }, [(_vm.loginAuth === 'login') ? _c('div', [_c('login-input', {
    attrs: {
      "showForgotPassword": _vm.showForgotPassword
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loginAuth === 'forgotPassword') ? _c('div', {
    staticClass: "forgot-password-input"
  }, [_c('div', {
    staticClass: "intro-text text-xs-center"
  }, [_c('h2', [_vm._v("Forgot Password")])]), _vm._v(" "), _c('forgot-password-input', {
    attrs: {
      "showLogin": _vm.showLogin
    }
  })], 1) : _vm._e()])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-640ff1a0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LoginPage/index.vue
// module id = 1751
// module chunks = 180